<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddSubjectFlag" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="上传营业执照" :label-width="formLabelWidth">
                <el-upload class="avatar-uploader"
                           action
                           :http-request="(file) => httpRequest(file)"
                           :show-file-list="false"
                           :on-success="handleSuccess"
                           accept=".jpg,.png,.jpeg,.bmp"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="主体名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入主体名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="统一社会信用代码" prop="credit_code" :label-width="formLabelWidth">
                <el-input v-model="addFrom.credit_code" placeholder="请输入统一社会信用代码" clearable
                          style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="注册资本" :label-width="formLabelWidth">
                <el-input v-model="addFrom.registered_capital" placeholder="请输入注册资本" clearable
                          style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="法人" :label-width="formLabelWidth">
                <el-input v-model="addFrom.legal_person" placeholder="请输入法人" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="公司地址" :label-width="formLabelWidth">
                <el-input v-model="addFrom.residence" placeholder="请输入公司地址" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="经营范围" :label-width="formLabelWidth" style="width: 90%;">
                <el-input type="textarea" clearable placeholder="请输入经营范围" v-model="addFrom.business_scope">
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="主体类型" :label-width="formLabelWidth">
                <el-input v-model="addFrom.subject_type" placeholder="请输入主体类型" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="营业期限" :label-width="formLabelWidth">
                <el-input v-model="addFrom.business_term" placeholder="请输入营业期限" clearable
                          style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="成立日期" :label-width="formLabelWidth">
                <el-date-picker
                    v-model="addFrom.set_date"
                    type="date"
                    placeholder="选择成立日期"
                    value-format="yyyy-MM-dd"
                    style="width: 90%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="登记日期" :label-width="formLabelWidth">
                <el-date-picker
                    v-model="addFrom.register_date"
                    type="date"
                    placeholder="选择登记日期"
                    value-format="yyyy-MM-dd"
                    style="width: 90%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="登记机关" :label-width="formLabelWidth">
                <el-input v-model="addFrom.business_term" placeholder="请输入登记机关" clearable
                          style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合作类型：" prop="cooperate_type" :label-width="formLabelWidth">
                <SelectChecked :options="typeOptions" placeholder="请选择合作类型" :isRemoveAllTag="isRemoveAllTag"
                               @selectedVal="selectedReferral" style="width: 90%;"/>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="联系人" :label-width="formLabelWidth">
                <el-input v-model="addFrom.contact" placeholder="请输入联系人" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="联系方式" :label-width="formLabelWidth">
                <el-input v-model="addFrom.contact_details" placeholder="请输入联系方式" clearable
                          style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 90%;">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  props: ['AddSubjectFlag', "editID", "types"],
  components: {
    SelectChecked
  },
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        registered_capital: "",
        legal_person: "",
        residence: "",
        business_scope: "",
        subject_type: "",
        business_term: "",
        set_date: "",
        register_date: "",
        register_office: "",
        license: "",
        name: "",
        credit_code: "",
        cooperate_type: '',
        contact: "",
        contact_details: "",
        status: 1,
        id: "",
      },
      rules: {
        // license: [
        //   {required: true, message: '请上传营业执照', trigger: 'blur'},
        // ],
        name: [
          {required: true, message: '请输入主体名称', trigger: 'blur'},
        ],
        credit_code: [
          {required: true, message: '请输入统一社会信用代码', trigger: 'blur'},
        ],
        cooperate_type: [
          {required: true, message: '请选择合作类型', trigger: 'change'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],

      },
      imageUrl: '',
      typeOptions: [],
      isRemoveAllTag: 0,
    };
  },
  created() {

  },
  methods: {

    httpRequest(file) {
      let api = MoneyManagementAPI()

      let imageUpload = new FormData();
      imageUpload.append("file", file.file);

      api.fileUpload(imageUpload).then((res) => {
        if (res.code == 0) {
          this.imageUrl = res.data.url_full;
          this.addFrom.license = res.data.url;
          let orcText = res.data.orc_text;
          this.addFrom.name = orcText.Name;
          this.addFrom.credit_code = orcText.RegNum;
          this.addFrom.registered_capital = orcText.Capital;
          this.addFrom.legal_person = orcText.Person;
          this.addFrom.residence = orcText.Address;
          this.addFrom.business_scope = orcText.Business;
          this.addFrom.subject_type = orcText.Type;
          this.addFrom.business_term = orcText.Period;
          this.addFrom.set_date = this.formatDate(orcText.SetDate);
          this.addFrom.register_date = this.formatDate(orcText.RegistrationDate);
          this.addFrom.register_office = orcText.RegistrationAuthority;
        } else {
          processErrors(res);
        }
      });
    },

    formatDate(dateString) {
      // 使用正则表达式替换格式
      return dateString.replace(/(\d{4})年(\d{2})月(\d{2})日/, '$1-$2-$3');
    },

    handleSuccess(res, file) {
      this.addFrom.license = URL.createObjectURL(file.raw);
    },

    handleClose(done) {
      this.isRemoveAllTag += 1;
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    selectedReferral(value) {
      this.addFrom.cooperate_type = value.join(',');
    },

    AddNone() {
      this.addFrom = []
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.addFrom.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }

          let api = MoneyManagementAPI()
          api.subjectAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.isRemoveAllTag += 1;
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });

    }
  },

  mounted() {
    this.typeOptions = JSON.parse(JSON.stringify(this.types))
    if (this.editID != "") {
      let api = MoneyManagementAPI()
      api.subjectInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = {
            registered_capital: res.data.registered_capital,
            legal_person: res.data.legal_person,
            residence: res.data.residence,
            business_scope: res.data.business_scope,
            subject_type: res.data.subject_type,
            business_term: res.data.business_term,
            set_date: res.data.set_date == '0000-00-00' ? '' : res.data.set_date,
            register_date: res.data.register_date == '0000-00-00' ? '' : res.data.register_date,
            register_office: res.data.register_office,
            license: res.data.license,
            name: res.data.name,
            credit_code: res.data.credit_code,
            cooperate_type: res.data.cooperate_type,
            contact: res.data.contact,
            contact_details: res.data.contact_details,
            status: res.data.status,
            id: res.data.id,
          }

          if (res.data.cooperate_type) {
            this.typeOptions = this.typeOptions.map(item => {
              return {
                ...item,
                check: res.data.cooperate_type.split(',').includes(item.value)
              };
            });
          }

          this.imageUrl = res.data.license_full;
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>